module.exports = __webpack_public_path__ + "static/media/jenkins.eb2178c8.png";